export enum ScheduleRecurrencePatternType {
  BY_DAYS,
  SPECIFIC_DATES,
  METERED_READINGS
}

export enum ScheduleRecurrencePatternLabelType {
  BY_DAYS = 'By days',
  SPECIFIC_DATES = 'Specific dates',
  METERED_READINGS = 'Metered readings'
}

export enum ScheduleTimeBasedPattern {
  DAYS,
  WEEKS,
  MONTHS,
  YEARS
}

export enum TimeBasedSchedulePatternType {
  DAYS,
  WEEKS,
  MONTHS,
  YEARS
}

export const TimeBasedSchedulePatternLabel = {
  [ScheduleTimeBasedPattern.DAYS]: 'Days',
  [ScheduleTimeBasedPattern.WEEKS]: 'Weeks',
  [ScheduleTimeBasedPattern.MONTHS]: 'Months',
  [ScheduleTimeBasedPattern.YEARS]: 'Years'
}

export enum ScheduleTimeBasedPatternLabelType {
  DAYS = 'Days',
  WEEKS = 'Weeks',
  MONTHS = 'Months',
  YEARS = 'Years'
}

export enum DaysOfWeek {
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
  SUNDAY = 0
}

export enum DaysOfWeekLabelType {
  MONDAY = 'Mon',
  TUESDAY = 'Tue',
  WEDNESDAY = 'Wed',
  THURSDAY = 'Thu',
  FRIDAY = 'Fri',
  SATURDAY = 'Sat',
  SUNDAY = 'Sun'
}
